/* Progressive enhancement. The native details menu also works without JS. */
(() => {
  function init(scope = document) {
    const headers = [...scope.querySelectorAll('[data-octas-navigation]')];
    if (scope.matches?.('[data-octas-navigation]')) headers.push(scope);
    headers.forEach(header => {
      if (header.dataset.navigationReady) return;
      header.dataset.navigationReady = 'true';
      const details = header.querySelector('details');
      const toggle = details?.querySelector('summary');
      if (!details || !toggle) return;
      const controller = new AbortController();
      const options = {signal:controller.signal};
      const close = (restoreFocus = false) => {
        details.open = false;
        if (restoreFocus) toggle.focus({preventScroll:true});
      };
      header.addEventListener('keydown', event => {
        if (event.key === 'Escape' && details.open) {
          event.preventDefault();
          close(true);
        }
      }, options);
      details.addEventListener('focusout', event => {
        if (event.relatedTarget && !details.contains(event.relatedTarget)) close();
      }, options);
      document.addEventListener('pointerdown', event => {
        if (details.open && !header.contains(event.target)) close();
      }, options);
      details.querySelectorAll('a').forEach(link => link.addEventListener('click', () => close(), options));
      const desktop = matchMedia('(min-width:901px)');
      desktop.addEventListener('change', event => {if (event.matches) close();}, options);
      document.addEventListener('shopify:section:unload', event => {
        if (event.target.contains(header)) controller.abort();
      }, options);
    });
  }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', () => init()) : init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
